import { Stack } from "@mui/material";
import { Illustration, Title } from "@src/appV2/redesign/system/ui-components";

export function EducateNewWorkerTitle() {
  return (
    <Stack gap={5} alignItems="center">
      <Illustration type="warning" />
      <Title variant="h3" component="h3" sx={{ textAlign: "center" }}>
        Always Cancel Early
      </Title>
    </Stack>
  );
}
